import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { stateConvert } from 'utils/stateAbbreviation';
import TaxId from './TaxId';
import { adminUpdateUserApi, checkIsZipCode } from 'redux/actions/manageAccount';
import { Container, GridContainer, InputFieldsWrapper } from 'styles/pages/manage-account'
import TextInput from 'components/FormElements/TextInput';
import PhoneNumber from 'components/FormElements/PhoneNumber';
import EditIcon from "assets/svg/PtPlusUserViewEditIcon";
import { useText } from "locales/useGetText";
import AlertModal from 'components/AlertModal';
import { getStateAbbr, getLoggedInUserCountry } from 'helpers'

function BasicInfo(pageProps) {
  const dispatch = useDispatch();
  const navigate = useNavigate();

  const loggedInUserInfo = JSON.parse(localStorage.getItem('loggedInUserData'))
  const token = loggedInUserInfo?.token
  const userCountry = getLoggedInUserCountry();
  const [saveDisableState, setSaveDisableState] = useState(true)
  const [isValidEmail, setIsValidEmail] = useState(true)
  const [isValidZip, setIsValidZip] = useState(true)
  const [accordionOpen, setAccordionOpen] = useState(true)
  const [alertModal, setAlertModal] = useState(false);
  const [alertModalContent, setAlertModalContent] = useState('');
  let pageFieldValues = pageProps.formikProps.values
  const [modalLink, setModalLink] = useState("");

  useEffect(() => {
    if (pageProps.pageData) resetFieldsFunction(pageProps.pageData)
  }, [pageProps.pageData])

  useEffect(() => {
    let fieldValues = pageProps.formikProps.values
    let errorkeys = []
    if (pageProps.formikProps?.errors) {
      errorkeys = Object.keys(pageProps.formikProps.errors)
    }
    let pageErrors = false
    if (errorkeys.length < 15 && pageProps.formikProps?.errors?.phoneNumber) pageErrors = true
    if (isValidZip && !pageErrors && fieldValues.userName?.trim() !== '' && fieldValues.phoneNumber?.trim() !== '' && fieldValues.businessName?.trim() !== '' && fieldValues.email?.trim() !== '' &&
      fieldValues.address?.trim() !== '' && fieldValues.city?.trim() !== '' && fieldValues.state?.trim() !== '' && fieldValues.zip?.trim() !== '') {
      setSaveDisableState(false)
    } else setSaveDisableState(true)
  }, [pageProps.formikProps, pageProps.errors, isValidEmail, isValidZip])

  const [alertType, setAlertType] = useState()
  const updateApiFunction = async () => {
    let id = pageProps.pageData.id
    let url = `/user/basic_info_update/${id}`
    let fieldValues = pageProps.formikProps.values
    let response = '';
    let data = {
      contactNumber: fieldValues.phoneNumber?.trim(),
      customerName: fieldValues.userName?.trim(),
      locationName: fieldValues.businessName?.trim(),
      emailAddress: fieldValues.email?.trim(),
      address: {
        name: fieldValues.businessName?.trim(),
        contactNumber: fieldValues.phoneNumber?.trim(),
        locationName: fieldValues.businessName?.trim(),
        street: fieldValues.address?.trim(),
        city: fieldValues.city?.trim(),
        state: fieldValues.state?.trim(),
        zipCode: fieldValues.zip?.trim()
      }
    }
    response = await dispatch(adminUpdateUserApi(url, data, token))
    if (response.success) {
      if (loggedInUserInfo) {
        loggedInUserInfo.name = fieldValues.userName?.trim();
        localStorage.setItem('loggedInUserData', JSON.stringify(loggedInUserInfo));
      }
      setAlertType("preferences")
      setAlertModalContent('The following preferences will be saved as your default preferences.')
      setAlertModal(!alertModal)

    } else {
      setAlertType()
      if (response?.data?.error?.message === "Invalid Token" || response.message === 'Request failed with status code 401') {
        navigate('/')
      } else {
        setAlertModalContent(response.message)
        setAlertModal(!alertModal)
      }
    }
  }

  const zipChangeHandler = async (value) => {
    let response = '';
    if (value.length === 5) {
      response = await dispatch(checkIsZipCode(value, token))
      if (response.success) {
        setIsValidZip(true)
        let stateAbb = stateConvert(response.data?.state)
        pageProps.setFieldValue('state', stateAbb || response.data?.state)
        pageProps.setFieldValue('city', response.data?.city)
      } else {
        if (response?.data?.error?.message === 'Invalid Zip Code.') {
          setIsValidZip(false)
          pageProps.setFieldValue('state', '')
          pageProps.setFieldValue('city', '')
        } else if (response?.data?.error?.message === "Invalid Token" || response.message === 'Request failed with status code 401') {
          navigate('/')
        } else {
          setAlertModalContent(response.message || 'Something went wrong, please try again.')
          setAlertModal(!alertModal)
        }
      }
    } else {
      setIsValidZip(true)
      pageProps.setFieldValue('state', '')
      pageProps.setFieldValue('city', '')
    }
  }

  const resetFieldsFunction = (initailValues) => {
    let initailData
    if (initailValues) initailData = initailValues
    else initailData = pageProps.pageData
    if (initailData) {
      pageProps.setFieldValue('phoneNumber', initailData.contactNumber)
      pageProps.setFieldValue('userName', initailData.customerName)
      pageProps.setFieldValue('email', initailData.emailAddress)
      pageProps.setFieldValue('businessName', initailData.locationName || initailData.locationAddress?.locationName)
      pageProps.setFieldValue('address', initailData.locationAddress?.street)
      pageProps.setFieldValue('city', initailData.locationAddress?.city)
      pageProps.setFieldValue('state', getStateAbbr(initailData.locationAddress?.state, userCountry))
      pageProps.setFieldValue('zip', initailData.locationAddress?.zipCode)
      pageProps.setFieldValue('billToPhoneNumber', initailData.contactNumber)
    }
  }

  return (
    <>
      <Container>
        {/* <AccordionHeader>
                    <h6 onClick={() => {
                        if (accordionOpen) setAccordionOpen(false)
                        else setAccordionOpen(true)
                    }}>Company Profile</h6>
                    {accordionOpen ?
                        <h4 onClick={() => setAccordionOpen(false)}><i></i></h4>
                        : <h5 onClick={() => setAccordionOpen(true)}><i></i></h5>
                    }
                </AccordionHeader> */}
        {/* {accordionOpen && */}
        <GridContainer>
          <h6 onClick={() => {
            // if (accordionOpen) setAccordionOpen(false)
            // else setAccordionOpen(true)
          }}>{pageProps.locale('companyInformation')}</h6>
          <InputFieldsWrapper>
            <div className="row">
              <div className="col-md-4 fixed-height">
                <div className='height-adjust'><TextInput name='businessName' disabled placeholder={pageProps.locale('companyName')} inputType='CompanyName' /></div>
              </div>

              <div className="col-md-4 fixed-height">
                <div className='height-adjust'><TextInput name='address' disabled placeholder={pageProps.locale('address')} maxLength={200} inputType='addressText' /></div>
              </div>
            </div>
            <div className="row">
              <div className="col-md-4 fixed-height">
                <div className='height-adjust'><TextInput name="city" disabled placeholder={pageProps.locale('city')} inputType='onlyText' /></div>
              </div>
              <div className="col-md-4 fixed-height">
                <div className='height-adjust'><TextInput name="state" placeholder={userCountry === 'CANADA' ? pageProps.locale('province') : pageProps.locale('state')} disabled inputType='text' /></div>
              </div>
              <div className={!isValidZip ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                <div className='height-adjust'><TextInput name="zip" disabled placeholder={userCountry === 'CANADA' ? pageProps.locale('postalCode') : pageProps.locale('zip')} maxLength={userCountry === 'CANADA' ? 7 : 5} onChangeHandler={zipChangeHandler} inputType='returnText' />
                  {!isValidZip && <p style={{ marginTop: '-1px' }}>{pageProps.locale('zipInvalid')}</p>}
                </div>
              </div>
            </div>
            <div className="row">
              {/* <div className="col-md-4 fixed-height">
                                    <div className='height-adjust'><PhoneNumber name="phoneNumber" disabled placeholder={`Company Phone Number*`} /></div>
                                </div> */}
              <div className="col-md-4 fixed-height">
                <div className='height-adjust'><TextInput name='userName' disabled placeholder={pageProps.locale('contactName')} maxLength={50} inputType='onlyText' /></div>
              </div>

              <div className={!isValidEmail ? 'col-md-4 fixed-height error-styling-input' : 'col-md-4 fixed-height'}>
                <div className='height-adjust'><TextInput disabled name="email" placeholder={pageProps.locale('contactEmail')} maxLength={100} />
                  {!isValidEmail && <p style={{ marginTop: '-7px' }}>{pageProps.locale('emailAlreadyExists')}</p>}
                </div>
              </div>
              {loggedInUserInfo?.locationType === 'PARENT_LOCATION' &&
                <div className="col-md-4 fixed-height">
                  <div className='height-adjust'><PhoneNumber name="billToPhoneNumber" disabled placeholder={pageProps.locale('contactPhone')} /></div>
                </div>
              }
            </div>
            {/* <TaxId formikProps={pageProps} pageData={pageProps.draftData} setFieldValue={pageProps?.setFieldValue} /> */}
          </InputFieldsWrapper>
          {/* <div className='view-edit-button-section'>
                            <button className={saveDisableState ? 'save-button disabled' : 'save-button'} disabled={saveDisableState} onClick={() => updateApiFunction()}><EditIcon />Update</button>
                            <button className='cancel-button' onClick={() => resetFieldsFunction()}>Cancel</button>
                        </div> */}
        </GridContainer>
        {/* } */}
      </Container>

      <AlertModal
        isOpen={alertModal}
        toggle={() => setAlertModal(!alertModal)}
        // title="Alert"
        content={alertModalContent}
        link={modalLink}
        className="alert-msg-container"
        InnerClassName="alert-msg"
        callBackAlert={() => {
          if (alertType === "preferences") {
            window.location.reload(true)
          }
        }}
      />
    </>
  )
}

export default BasicInfo
